import { render, staticRenderFns } from "./CompanyProductValues.vue?vue&type=template&id=ae949ca4&scoped=true"
import script from "./CompanyProductValues.vue?vue&type=script&lang=js"
export * from "./CompanyProductValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae949ca4",
  null
  
)

export default component.exports